import { render, staticRenderFns } from "./stardisplay.vue?vue&type=template&id=f4dfb1b0&"
import script from "./stardisplay.vue?vue&type=script&lang=js&"
export * from "./stardisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4dfb1b0')) {
      api.createRecord('f4dfb1b0', component.options)
    } else {
      api.reload('f4dfb1b0', component.options)
    }
    module.hot.accept("./stardisplay.vue?vue&type=template&id=f4dfb1b0&", function () {
      api.rerender('f4dfb1b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Z9AB1gbL4Rz7/JS/comp/stardisplay.vue"
export default component.exports